/** PLAYER PROFILE — a small card behind a tapped name.
 *
 *  Everything in it is already on the board: the screen name, the
 *  establishment (or "Off loc"), the points bank, pick accuracy, tonight's
 *  wins, the winner pick and the star of the night. No email, no phone, no
 *  contact detail — the feed this reads carries none.
 */
import { X } from 'lucide-react';

const Line = ({ label, value, testid }) => (
    <div className="flex items-center justify-between gap-3 border-b border-white/10 py-1.5 last:border-0">
        <span className="text-[11px] uppercase tracking-wide opacity-60">{label}</span>
        <span className="text-sm font-semibold tabular-nums" data-testid={testid}>{value}</span>
    </div>
);

export const GoalPlayerProfile = ({ player, t, c, ty, onClose, pointsOn = true }) => {
    if (!player) return null;
    const right = player.right_percent === null || player.right_percent === undefined
        ? t('goalGame.boardNew')
        : `${player.right_percent}%`;
    return (
        <div className="absolute inset-0 z-50 flex items-center justify-center p-4"
             data-testid="lp-profile-wrap">
            <button type="button" aria-label="close" onClick={onClose} data-testid="lp-profile-scrim"
                    className="absolute inset-0 bg-black/70" />
            <div className="relative w-full max-w-sm rounded-2xl border border-white/15 p-4 sw-rise"
                 style={{ backgroundColor: c.bg || '#0b1220', color: c.text, ...ty.body }}
                 data-testid="lp-profile">
                <div className="mb-3 flex items-start justify-between gap-3">
                    <div className="min-w-0">
                        <p className="text-[11px] uppercase tracking-wide opacity-60">
                            {t('goalGame.profileTitle')}
                        </p>
                        <p className="truncate text-lg font-bold" style={ty.headline}
                           data-testid="lp-profile-name">{player.player}</p>
                        <p className="truncate text-xs opacity-70" data-testid="lp-profile-place">
                            {player.establishment || t('goalGame.chatOffLoc')}
                        </p>
                    </div>
                    <button type="button" onClick={onClose} data-testid="lp-profile-close"
                            aria-label={t('goalGame.profileClose')}
                            className="rounded-full border border-white/25 p-1.5">
                        <X size={16} />
                    </button>
                </div>
                {pointsOn && (
                    <Line label={t('goalGame.boardPoints')} value={player.points}
                          testid="lp-profile-points" />
                )}
                <Line label={t('goalGame.profileAccuracy')} value={right}
                      testid="lp-profile-right" />
                <Line label={t('goalGame.profileWins')} value={player.wins}
                      testid="lp-profile-wins" />
                <Line label={t('goalGame.boardPick')} value={player.winner_pick || '—'}
                      testid="lp-profile-pick" />
                <Line label={t('goalGame.boardStar')} value={player.star_pick || '—'}
                      testid="lp-profile-star" />
            </div>
        </div>
    );
};

export default GoalPlayerProfile;
